import Image from "next/image";
import Link from "next/link";

export const Logo = ({
  showText = true,
  href = "/",
}: {
  showText?: boolean;
  href?: string;
}) => {
  return (
    <Link href={href} className="flex items-center space-x-2">
      <Image
        src="https://res.cloudinary.com/damvy8xvv/image/upload/v1753041608/hofwams-logo_mbiy92.png"
        alt="Hofwams Logo"
        width={32}
        height={32}
        className="rounded-lg"
      />
      {showText && (
        <span className="text-primary/90 dark:text-primary text-xl font-bold">
          Hofwams
        </span>
      )}
    </Link>
  );
};
